import React, { PureComponent } from 'react';

import './Tabs.css';

export default class Tab extends PureComponent {

    render() {
        const { style, children } = this.props;
        return (
            <div style={ style }>
                { children }
            </div>
        );
    }
}